import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_clipboard_4594bde4 from 'nuxt_plugin_clipboard_4594bde4' // Source: ./clipboard.js (mode: 'client')
import nuxt_plugin_templatesplugin67b1b23f_4e7d61c1 from 'nuxt_plugin_templatesplugin67b1b23f_4e7d61c1' // Source: ./templates.plugin.67b1b23f.js (mode: 'all')
import nuxt_plugin_componentsglobalcomponentsplugin12c850ac_2255b0ac from 'nuxt_plugin_componentsglobalcomponentsplugin12c850ac_2255b0ac' // Source: ./components.global-components.plugin.12c850ac.js (mode: 'all')
import nuxt_plugin_webfontloader_2f2f82f8 from 'nuxt_plugin_webfontloader_2f2f82f8' // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_axios_1759bc84 from 'nuxt_plugin_axios_1759bc84' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_50e7d45a from 'nuxt_plugin_gtm_50e7d45a' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_prism_22f995cd from 'nuxt_plugin_prism_22f995cd' // Source: ../plugins/prism (mode: 'client')
import nuxt_plugin_vueslidercomponent_c11eff28 from 'nuxt_plugin_vueslidercomponent_c11eff28' // Source: ../plugins/vue-slider-component (mode: 'client')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"twopac","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Nuxt-based Paccurate Website"},{"name":"apple-mobile-web-app-title","content":"Paccurate"},{"name":"application-name","content":"Paccurate"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"theme-color","content":"#ffffff"},{"hid":"og:title","name":"title","property":"og:title","content":"Paccurate is a smart, cost-aware cartonization API"},{"hid":"og:image","name":"image","property":"og:image","content":"https:\u002F\u002Fpaccurate.io\u002Fsite-preview.PNG"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:description","name":"description","property":"og:description","content":"Smart cartonization considers your rates and other fulfillment costs when generating a packing solution, and stacks, nests, and rolls your items to take up less space. Try the API free."},{"hid":"twitter:card","property":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","property":"twitter:site","content":"@paccurateio"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#5bbad5"},{"rel":"shortcut icon","href":"\u002Ffavicon.ico"}],"script":[{"hid":"hs-form-code","src":"\u002F\u002Fjs.hsforms.net\u002Fforms\u002Fshell.js","charset":"utf-8","defer":true},{"hid":"hs-script-loader","src":"\u002F\u002Fjs.hs-scripts.com\u002F702696.js","defer":true,"body":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-58PF7Z7')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-58PF7Z7&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (process.client && typeof nuxt_plugin_clipboard_4594bde4 === 'function') {
    await nuxt_plugin_clipboard_4594bde4(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin67b1b23f_4e7d61c1 === 'function') {
    await nuxt_plugin_templatesplugin67b1b23f_4e7d61c1(app.context, inject)
  }

  if (typeof nuxt_plugin_componentsglobalcomponentsplugin12c850ac_2255b0ac === 'function') {
    await nuxt_plugin_componentsglobalcomponentsplugin12c850ac_2255b0ac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_2f2f82f8 === 'function') {
    await nuxt_plugin_webfontloader_2f2f82f8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_1759bc84 === 'function') {
    await nuxt_plugin_axios_1759bc84(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_50e7d45a === 'function') {
    await nuxt_plugin_gtm_50e7d45a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_prism_22f995cd === 'function') {
    await nuxt_plugin_prism_22f995cd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueslidercomponent_c11eff28 === 'function') {
    await nuxt_plugin_vueslidercomponent_c11eff28(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
